import React from "react";
import { useAppDispatch, useAppSelector } from "../../common/hooks/hooks";
import { openMultiPanelOffcanvas } from "../../common/features/multiPanelOffcanvas/multiPanelOffcanvasSlice";
import { selectWishlistCount } from "../../templates/ecommerce/wishlist/wishlistSelectors";
import { selectCartCount } from "../../templates/ecommerce/cart/cartSelectors";
import { selectCompareCount } from "../../templates/ecommerce/compare/compareSelectors";
import { useGetCartQuery } from "../../templates/ecommerce/cart/api/cartApi";
import { useGetWishlistQuery } from "../../templates/ecommerce/wishlist/api/wishlistApi";
import { useGetCompareListQuery } from "../../templates/ecommerce/compare/api/compareApi";
import Icon from "../../common/components/Icon/Icon";

const UserActions: React.FC = () => {
  useGetCartQuery();
  useGetWishlistQuery();
  useGetCompareListQuery();

  const dispatch = useAppDispatch();
  const itemsCount = useAppSelector(selectCartCount);
  const wishlistCount = useAppSelector(selectWishlistCount);
  const compareCount = useAppSelector(selectCompareCount);

  // --- B2B & Auth Check Variables ---
  const isLoggedIn = window.commonVariables?.isLoggedIn || false;
  const isApprovedMember = window.commonVariables?.isApprovedMember || false;
  const loginUrl = window.commonVariables?.loginUrl || "/wp-login.php";
  const myAccountUrl = window.commonVariables?.myAccountUrl || "/my-account";
  const userUrl = isLoggedIn ? myAccountUrl : loginUrl;
  const userAriaLabel = isLoggedIn ? "My Account" : "Login / Register";

  // --- Click Handlers with Auth Guards ---
  const handleOpenSearch = () => {
    dispatch(openMultiPanelOffcanvas("search"));
  };

  const handleOpenCart = () => {
    if (!isApprovedMember) {
      window.location.href = loginUrl;
      return;
    }
    dispatch(openMultiPanelOffcanvas("cart"));
  };

  const handleOpenWishlist = () => {
    if (!isApprovedMember) {
      window.location.href = loginUrl;
      return;
    }
    dispatch(openMultiPanelOffcanvas("wishlist"));
  };

  // Compare page is a standard link, restrict its URL if not approved
  const compareUrl = isApprovedMember
    ? window.commonVariables?.compareUrl || "/compare"
    : loginUrl;

  return (
    <div className="user-actions">
      {/* Search Icon (Arama herkese açık olabilir) */}
      <button
        className="user-actions__link"
        aria-label="Search"
        onClick={handleOpenSearch}
      >
        <Icon iconName="search" className="icon--stroke-thick" />
      </button>

      <div className="user-actions__separator"></div>

      {/* Cart Icon */}
      <button
        className="user-actions__link user-actions__cart"
        aria-label="Shopping Cart"
        onClick={handleOpenCart}
      >
        <Icon iconName="shopping-cart-outline" className="icon--stroke-thick" />
        {itemsCount > 0 && <span className="cart-badge">{itemsCount}</span>}
      </button>

      <div className="user-actions__separator"></div>

      {/* Wishlist Icon */}
      <button
        className="user-actions__link user-actions__wishlist"
        aria-label="Wishlist"
        onClick={handleOpenWishlist}
      >
        <Icon iconName="heart-outline" className="icon--stroke-thick" />
        {wishlistCount > 0 && (
          <span className="wishlist-badge">{wishlistCount}</span>
        )}
      </button>

      <div className="user-actions__separator"></div>

      {/* Compare Icon Link */}
      <a
        href={compareUrl}
        className="user-actions__link user-actions__compare"
        aria-label="Compare Products"
      >
        <Icon iconName="arrows-right-left" className="icon--stroke-thick" />
        {compareCount > 0 && (
          <span className="compare-badge">{compareCount}</span>
        )}
      </a>

      <div className="user-actions__separator"></div>

      {/* User Icon Link */}
      <a
        href={userUrl}
        className="user-actions__link user-actions__user-profile"
        aria-label={userAriaLabel}
      >
        <Icon iconName="user" className="icon--stroke-thick" />
      </a>
    </div>
  );
};

export default UserActions;
